export default "__VITE_PUBLIC_ASSET__a8ddc86a__"